document.addEventListener('DOMContentLoaded', () => {
  const BOOKING_FEE_VARIANT_ID = 53457796825352;

  let syncTimeout = null;
  let isSyncing = false;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function isTicketProductType(productType) {
    const type = normalize(productType);
    return type === 'event' || type === 'trip';
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  async function updateCartByKey(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });
  }

  async function addBookingFee(quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: BOOKING_FEE_VARIANT_ID,
            quantity,
            properties: {
              _booking_fee: 'true'
            }
          }
        ]
      })
    });
  }

  async function syncBookingFee() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await getCart();

      let totalTicketQty = 0;
      let bookingFeeItem = null;
      const updates = {};

      cart.items.forEach((item) => {
        const isBookingFee =
          Number(item.variant_id) === Number(BOOKING_FEE_VARIANT_ID) ||
          (item.properties && item.properties._booking_fee === 'true');

        const isEventTicketByProperties =
          item.properties && item.properties._event_ticket === 'true';

        const isEventTicketByProductType =
          isTicketProductType(item.product_type);

        const isEventTicket = !isBookingFee && (isEventTicketByProperties || isEventTicketByProductType);

        if (isBookingFee) {
          bookingFeeItem = item;
        } else if (isEventTicket) {
          totalTicketQty += Number(item.quantity || 0);
        }
      });

      let changed = false;

      if (!bookingFeeItem && totalTicketQty > 0) {
        await addBookingFee(totalTicketQty);
        changed = true;
      } else if (bookingFeeItem) {
        if (totalTicketQty <= 0) {
          updates[bookingFeeItem.key] = 0;
          changed = true;
        } else if (Number(bookingFeeItem.quantity) !== Number(totalTicketQty)) {
          updates[bookingFeeItem.key] = totalTicketQty;
          changed = true;
        }
      }

      if (Object.keys(updates).length > 0) {
        await updateCartByKey(updates);
      }

      if (changed) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Booking fee sync failed:', error);
    } finally {
      isSyncing = false;
    }
  }

  function queueSync(delay = 800) {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(() => {
      syncBookingFee();
    }, delay);
  }

  syncBookingFee();

  document.addEventListener('change', (event) => {
    const target = event.target;

    if (
      target.matches('.quantity__input') ||
      target.matches('input[name="updates[]"]') ||
      target.closest('quick-order-list')
    ) {
      queueSync(500);
    }
  });

  document.addEventListener('input', (event) => {
    const target = event.target;

    if (
      target.matches('.quantity__input') ||
      target.matches('input[name="updates[]"]') ||
      target.closest('quick-order-list')
    ) {
      queueSync(650);
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target.closest(
      '.quantity__button, cart-remove-button a, cart-remove-button, .quick-order-list-remove-button button, quick-order-list-remove-all-button button'
    );

    if (target) {
      queueSync(700);
    }
  });
});